import {
  makeStyles,
  createStyles,
  Theme,
  Typography,
  Breadcrumbs,
  Link as MuiLink,
} from "@material-ui/core";
import clsx from "clsx";
import React, { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

export const BreadCrumb = ({ links }: BreadCrumbProps) => {
  const classes = useStyles();

  return (
    <Breadcrumbs
      separator=">"
      classes={{
        root: classes.root,
        separator: classes.separator,
      }}
    >
      {links.map(({ label, link }, index) =>
        link ? (
          <MuiLink
            key={index}
            color="inherit"
            className={clsx({
              [classes.leaf]: index === links.length - 1,
            })}
            to={link}
            component={RouterLink}
          >
            {label}
          </MuiLink>
        ) : (
          <Typography
            key={index}
            color="inherit"
            className={clsx({
              [classes.label]: true,
              [classes.leaf]: index === links.length - 1,
            })}
          >
            {label}
          </Typography>
        ),
      )}
    </Breadcrumbs>
  );
};

export type BreadCrumbLink = {
  label: string | ReactNode;
  link?: string;
};

export type BreadCrumbProps = {
  links: BreadCrumbLink[];
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "normal",
      color: theme.palette.battleshipGrey.main,
    },
    label: {
      fontSize: "inherit",
      fontWeight: "inherit",
      lineHeight: "inherit",
    },
    separator: {
      marginLeft: 3,
      marginRight: 3,
    },
    leaf: {
      color: theme.palette.primary.main,
    },
  }),
);
